module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [(!_vm.tenant) ? _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "outlined": "",
      "color": "indigo"
    },
    on: {
      "click": _vm.connect
    }
  }, [_c('v-icon', [_vm._v("mdi-arrow-up-circle-outline")]), _vm._v("Connect Xero\n  ")], 1) : _vm._e(), _vm._v(" "), (_vm.tenant) ? _c('div', [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "primary",
      "text-color": "white"
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-checkbox-marked-circle")])], 1), _vm._v("Connected\n    ")], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "outlined": "",
      "width": "100%"
    }
  }, [_c('v-card-title', [_vm._v(_vm._s(_vm.tenant.tenantName))]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
    staticClass: "ma-0 pa-0"
  }, [_vm._v(_vm._s(_vm.tenant.tenantType))]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pa-0"
  }, [_vm._v(_vm._s(_vm.tenant.tenantId))])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.syncXeroResource('Contacts')
      }
    }
  }, [_vm._v("Sync Contacts")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.syncXeroResource('Invoices')
      }
    }
  }, [_vm._v("Sync Invoices")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.syncXeroResource('Quotes')
      }
    }
  }, [_vm._v("Sync Quotes")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27b3599c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/xero/ConnectXero.vue
// module id = 2047
// module chunks = 0